<template lang="pug">
#flowContainer(v-loading="loading" element-loading-text="数据处理中...")
  .header
    .title 流程模板
    .oper
      el-button(size="small" @click="openSet" v-if="!noReturn") 返回
      //- 新增0 编辑1 查看2
      el-button(type="primary" size="small" v-if="viewMode === 0" @click="saveNowFlow") 保存流程
      el-button(type="primary" size="small" v-if="viewMode === 1" @click="saveNowFlow") 更新流程
  .designerCom
    .navMeau
      .nav( v-for="(item, index) in navList" :key="index" @click="navClick(index)"
        :class="{ 'basic': index === 0, 'process': index === navList.length - 1, 'isActive': activeName === index }" )
        img(v-if="!item.isIcon" :src="item.type === activeName ? item.icon1 : item.icon" alt="图标")
        i(v-else :class="[item.type === activeName ? 'iconActive' : '', item.icon]" alt="图标")
        span {{ item.name }}
    .content
      basicSetting(ref="basicSetting" v-show="activeName === 0" :source="source" :viewMode="viewMode")
      permission(ref="permission" v-show="activeName === 1" :source="source" :viewMode="viewMode")
      drawFlow(ref="drawFlow"  v-show="activeName === 2" :screenShot="screenShot" :source="source" :viewMode="viewMode")
      outputPrint(ref="outputPrint"  v-show="activeName === 3" :source="source" :viewMode="viewMode")
</template>

<script>
import basicSetting from "../editorCom/basicSetting.vue";
import EditMode from "@/CommonDP/enums/EditMode";
import permission from "../editorCom/permission.vue";
import drawFlow from "../editorCom/drawFlow.vue";
import outputPrint from "../editorCom/outputPrint.vue";
import { flowParams, updateflowImage } from "../config";
import flowService from "@/CommonDP/service/flow-service";
import html2Canvas from "html2canvas";
import { mapState } from "vuex";
import globalParams from "@/CommonDP/utils/globalParams";

export default {
  components: { basicSetting, permission, drawFlow, outputPrint },
  props: {
    // 0:新增 ;1: 编辑; 2 : 查看;
    viewMode: {
      type: Number,
      default: EditMode.CREATE_0
    },
    // 是流程设置模板还是低代码设置模板
    source: {
      type: String,
      default: "set"
    },
    noReturn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      screenShot: false,
      activeName: 0,
      navList: [
        { type: 0, name: "基础设置", icon: require("./../image/basis.png"), icon1: require("./../image/basis1.png") },
        { type: 1, name: "权限设置", icon: require("./../image/prem.png"), icon1: require("./../image/prem1.png") },
        { type: 2, name: "流程设置", icon: require("./../image/process.png"), icon1: require("./../image/process1.png") },
        { type: 3, name: "成果输出", isIcon: true, icon: "el-icon-printer" }
      ]
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    flowDefinitionId() {
      return flowParams.flowDefinitionId || "";
    },
    currentVersionId() {
      return flowParams.currentVersionId || "";
    }
  },
  created() {
    const onlinePrintDesign = globalParams.get("onlinePrintDesign");
    if (!onlinePrintDesign) {
      this.navList = this.navList.slice(0, 3);
    }
  },
  methods: {
    async navClick(index) {
      this.activeName = index;
    },
    openSet() {
      this.$emit("closeDesigner");
    },
    async saveNowFlow() {
      // 基础设置页必填项验证
      const booleanFrom = await this.$refs.basicSetting.validateFormData();
      if (!booleanFrom) {
        this.activeName = 0;
        return;
      }
      const { permForm, flowNode } = flowParams;

      // 权限设置页验证
      const { noApproveUserStrategy, defaultApproveUserId } = permForm;
      if (noApproveUserStrategy === 2 && !defaultApproveUserId) {
        this.activeName = 1;
        this.$message.info("请选择转交人");
        return;
      }
      // 流程设置页验证
      if (flowNode.length === 0) {
        this.activeName = 2;
        this.$message.info("请配置流程图");
        return;
      }
      this.screenShot = true;
      this.activeName = 2;
      // 等下个进程方便截图
      await this.$nextTick();
      this.loading = true;
      this.getFlowBase64();
    },
    // 获取流程图的base64的截图来保存
    async getFlowBase64() {
      const shareContent = this.$refs.drawFlow.$refs.flow.$refs.designView;
      // console.log("drawFlow", shareContent);
      const width = shareContent.offsetWidth;
      const height = shareContent.offsetHeight;
      const opts = {
        scrollY: 0,
        backgroundColor: "#f0f2f5",
        scrollX: 0,
        allowTaint: true, // 允许加载跨域的图片
        tainttest: true, // 检测每张图片都已经加载完成
        logging: true, // 日志开关，发布的时候记得改成false
        width, // dom 原始宽度
        height // dom 原始高度
      };
      await this.$nextTick();
      const canvas = await html2Canvas(shareContent, opts);
      updateflowImage(canvas.toDataURL());
      this.final();
    },
    async final() {
      const prjCategoryList = this.$refs.basicSetting.init();
      const { basicForm, permForm, flowNode, flowImage, attachedFiles } = flowParams;
      const params = {
        ...basicForm,
        prjCategoryList,
        ...permForm,
        nodes: JSON.stringify(flowNode),
        flowImage,
        attachedFiles,
        enterpriseId: this.enterpriseId
      };
      this.screenShot = false;
      console.log("nodes", flowNode);
      console.log("permForm", permForm);
      try {
        await this.requestUrl(params);
        this.$message.success("流程设置成功");
        this.$emit("closeDesigner", true);
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async requestUrl(params) {
      if (this.flowDefinitionId) {
        const dto = {
          ...params,
          flowDefinitionId: this.flowDefinitionId,
          currentVersionId: this.currentVersionId
        };
        await flowService.updateFlow(dto);
      } else if (this.source === "set") {
        await flowService.addNewFlow(params);
      } else if (this.source === "lowcode") {
        await flowService.flowNewAdd(params);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#flowContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.header {
  width: 100%;
  height: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  border-bottom: 1px solid #e5e8f1;
  .title {
    font-size: 16px;
    font-weight: 700;
  }
}
.designerCom {
  height: calc(100% - 50px);
  overflow-y: auto;
  background-color: #eff1f6;
  .navMeau {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    background-color: #fff;
    justify-content: center;
    align-items: center;
    // position: relative;
    .nav {
      width: 260px;
      height: 36px;
      margin-right: 18px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: #f5f5f5;
      position: relative;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
        margin-right: 5px;
      }
      span {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .nav::after {
      width: 0px;
      height: 0px;
      border-width: 18px;
      border-style: solid;
      border-color: transparent transparent transparent #f5f5f5;
      position: absolute;
      content: " ";
      right: -36px;
    }
    .nav::before {
      width: 0px;
      height: 0px;
      border-width: 18px;
      border-style: solid;
      border-color: transparent transparent transparent #fff;
      position: absolute;
      content: " ";
      left: 0px;
    }
    .basic::before {
      width: 0px;
      height: 0px;
      border-width: 18px;
      border-style: solid;
      border-color: transparent transparent transparent #f5f5f5;
      position: absolute;
      content: " ";
      left: 0px;
    }
    .process::after {
      width: 0px;
      height: 0px;
      border-width: 18px;
      border-style: solid;
      border-color: transparent transparent transparent #fff;
      position: absolute;
      content: " ";
      left: 0px;
    }
    .isActive {
      background: var(--theme-color);
      color: #fff;
    }
    .isActive::after {
      border-color: transparent transparent transparent var(--theme-color);
    }
    .basic.isActive::before {
      border-color: transparent transparent transparent var(--theme-color);
    }
    .process.isActive::after {
      border-color: transparent transparent transparent #fff;
    }
  }
  .content {
    margin-top: 10px;
    background-color: #fff;
    width: 100%;
    height: calc(100% - 60px);
    overflow-y: auto;
    padding: 10px;
  }
  i {
    font-size: 22px;
    margin-right: 5px;
  }
  .iconActive {
    color: #fff;
  }
}
</style>
